import Stack from '@mui/material/Stack';
import React, {
  memo,
  useCallback,
  useEffect,
  useState
} from 'react';

import dayjs, { Dayjs } from 'dayjs';

import ActionCalendar from 'src/components/calendar/schedule/ActionCalendar';
import WorkSchdule from 'src/components/calendar/schedule/workSchedule/WorkSchedule';
import { useStore } from 'src/context/StoreContext';

type ScheduleCustomProps = {
  openFilter: boolean;
};

const currentDate: Dayjs = dayjs();

const urlTab = {
  calendar: '/calendar/index',
  schedule: '/calendar/month',
};

const CalendarScheduleCustom = React.forwardRef<
  unknown,
  Omit<ScheduleCustomProps, 'ref'>
>((props, ref) => {
  const storeContext = useStore();
  const dateSelectedStore = storeContext.dateSelected;
  const setIsToday = storeContext.setIsToday;
  const [yearMonth, setYearMonth] = useState<string>(
    currentDate.format('YYYY-MM')
  );

  const handleChangeMonth = useCallback(
    async (yearMonth: string) => {
      setYearMonth(yearMonth);
    },
    // eslint-disable-next-line
    [yearMonth]
  );

  const handleClickToDay = useCallback(async () => {
    setIsToday(true);
    if (currentDate.format('YYYY-MM') !== yearMonth) {
      handleChangeMonth(currentDate.format('YYYY-MM'));
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    return () => {
      storeContext.setDateSelected(dayjs().format('YYYY-MM-DD'))
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const dayjsDate = dayjs(dateSelectedStore).format('YYYY-MM');

    if (dateSelectedStore !== '' && dayjsDate !== yearMonth) {
      handleChangeMonth(dayjsDate);
    }
    // eslint-disable-next-line
  }, [dateSelectedStore]);

  return (
    <Stack width={'100%'}>
      <ActionCalendar
        onChangeMonth={handleChangeMonth}
        onClickToDay={handleClickToDay}
        yearMonth={yearMonth}
        urls={urlTab}
      />
      <WorkSchdule
        openFilter={props.openFilter}
        dateSelected={dateSelectedStore}
        yearMonth={yearMonth}
      />
    </Stack>
  );
});

export default memo(CalendarScheduleCustom);
